export default () => ({
    leftNav: null,
});
  